import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { widgetScheduleConfig } from '@/shared/config/tests/e2e/widgets/schedule';
import { classNames } from '@/shared/lib/classnames/classnames';
import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';
interface ScheduleItemProps {
  item: IScheduleInMedcenter;
  formattedDate: string;
  isToday: boolean;
  dayName: string;
  hasOnlineBookingInMedcenter?: boolean;
  emptyTimeslots?: boolean;
  onClick?: (() => void) | (() => unknown);
}
export const ScheduleItem: React.FC<ScheduleItemProps> = ({
  item,
  formattedDate,
  dayName,
  isToday,
  emptyTimeslots,
  hasOnlineBookingInMedcenter,
  onClick
}) => {
  const t = useTranslations('doctor.schedule');
  const scheduleClick = () => {
    if (!item.isWork) return;
    if (typeof onClick === 'function') {
      onClick();
    }
  };
  const isWeekend = useMemo(() => {
    return emptyTimeslots && hasOnlineBookingInMedcenter || !item.isWork;
  }, [item.isWork, emptyTimeslots, hasOnlineBookingInMedcenter]);
  return <button data-testid={widgetScheduleConfig.ids.scheduleItem} className={classNames(`flex w-27 flex-none cursor-auto select-none flex-col rounded-2lg border border-solid px-3 py-2`, {
    'cursor-not-allowed opacity-50': isWeekend,
    'cursor-pointer hover:border-primary': !isWeekend && typeof onClick === 'function'
  })} onClick={scheduleClick} data-sentry-component="ScheduleItem" data-sentry-source-file="ScheduleItem.tsx">
      <p className="text-sm">{formattedDate}</p>
      <p className="mb-2 text-xs text-textSecondary">{isToday ? t('today') : dayName}</p>
      {isWeekend ? <p className="text-xs text-textSecondary">{t('weekend')}</p> : <p className="text-xs text-textSecondary">
          {item.is24HoursWork ? t('aroundTheClock') : t('period', {
        start: item.startTime,
        end: item.endTime
      })}
        </p>}
    </button>;
};